import ready from 'utils/ready';
import {$, $$} from 'utils/selector';

ready().then(() => {

  const className = '.slider-customerreview';
  const elements = $$(className);

  if (elements.length > 0) {

    Promise.all([
      import (/* webpackChunkName: "slider" */'swiper/core'),
      import (/* webpackChunkName: "slider" */'./slider.css'),
      import (/* webpackChunkName: "slider" */'swiper/swiper-bundle.css')
    ]).then(modules => {

      var Swiper = modules[0].default;
      var Navigation = modules[0].Navigation;
      var Pagination = modules[0].Pagination;

      Swiper.use([Navigation, Pagination]);

      elements.forEach(element => {

        let config = {
          autoHeight: true,
          loop: true,
          effect: 'slide',
          speed: 500,
          // autoplay: true,
          dynamicBullets: true,

          pagination: {
            el: '.swiper-pagination',
          },

          navigation: {
            hideOnClick: true,
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },

        };

        var mySwiper = new Swiper (element, config);

      });

    });

  }

});
